import { render, staticRenderFns } from "./discountdetails.vue?vue&type=template&id=52e6c8d2&scoped=true&"
import script from "./discountdetails.vue?vue&type=script&lang=js&"
export * from "./discountdetails.vue?vue&type=script&lang=js&"
import style0 from "./discountdetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./discountdetails.vue?vue&type=style&index=1&id=52e6c8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6c8d2",
  null
  
)

export default component.exports